import React, { Fragment, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
    Button, Input, Row, Label, Card, CardBody, CustomInput,
    InputGroupAddon, InputGroup, Nav, NavItem, CardHeader, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter, Table
} from "reactstrap";
import classnames from "classnames";
import { Colxx, Separator } from "../../../../../../components/common/CustomBootstrap";
import { AxiosAPI, getGroupID } from "../../../../../../helpers/AxiosAPI";
import { API_REST_API } from "../../../../../../constants/APIs";
import { NotificationManager } from "../../../../../../components/common/react-notifications";

const requestTypes = ['GET', 'POST', 'PUT'];

const authentication = [{ label: 'None', value: 'None' }, { label: 'Basic Auth', value: 'BasicAuth' }, { label: 'Bearer Token', value: 'BearerToken' }
    , { label: 'Fetch Token From Local Storage', value: 'FetchToken' }];

const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
        top:auto !important;
        bottom: 0 !important;
      }
      .active{
        background-color:transparent;
      }
      
      .btn-round {
        border-radius:5px!important;
      }
    
      .rtc:hover{
        background:none!important;
        color: black!important;
      }
      .nav-width{
        width: 'auto';
        background: '';
      }
      `;

export default function EndPoint({ id, settings, saveIntegration }) {
    const [activeTabs, setActiveTabs] = useState(['']);
    const [requestParam, setRequestParams] = useState();
    const [testResponse, setTestResponse] = useState([]);
    const [apiConfigurations, setApiConfigurations] = useState([
        {
            requestName: '',
            requestType: 'GET',
            endPointUrl: '',
            queryString: [],
            preRequest: {
                endPointUrl: ''
            },
            param: [],
            headers: [],
            requestBody: null,
            authentication: {
                authenticationName: 'None',
                authenticationSettings: {
                    user: '',
                    password: '',
                    token: '',
                }
            },
            responseParams: [
                {
                    path: '',
                    variableName: ''
                }
            ]
        }
    ]);

    const [testRequest, setTestRequest] = useState();
    const [isVisible, setIsVisible] = useState(false);
    const toggle = () => {
        setTestRequest();
        setTestResponse();
        setIsVisible(!isVisible);
    }

    const handleTestConfiguration = (index) => {
        handleSave();
        let directFetch = true;
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i)[0];
        if (obj !== undefined) {
            let request = {
                integrationId: id,
                groupId: getGroupID(),
                requestName: obj.requestName,
                endPointUrl: obj.endPointUrl,
                requestBody: {

                }
            };
            if (obj?.authentication && obj.authentication?.authenticationName && obj.authentication.authenticationName === 'FetchToken') {
                directFetch = false;
                request.authentication = {
                    token: ''
                }
            }
            if (obj?.queryString && obj.queryString.length > 0)
                request.requestBody.queryStrings = obj.queryString.filter(p => p.value === '');

            if (obj?.headers && obj.headers.length > 0) {
                request.requestBody.headers = obj.headers.filter(p => p.value === '');
            }
            if (obj?.param && obj.param.length > 0) {
                request.requestBody.param = obj.param.filter(p => p.value === '');
            }
            if (obj?.requestBody && obj.requestBody != null && obj.requestBody !== '') {

                request.requestBody.body = obj.requestBody;
            }
            if (obj.preRequest != null && obj.preRequest.endPointUrl !== undefined && obj.preRequest.endPointUrl !== '') {
                let preRequest = apiConfigurations.filter(f => f.endPointUrl === obj.preRequest.endPointUrl)[0];
                if (preRequest !== undefined) {
                    if (preRequest?.queryString && preRequest.queryString.length > 0) {
                        preRequest.queryString.filter(p => p.value === '').map((m) => request.requestBody.queryStrings.push(m));
                    }

                    if (preRequest?.headers && preRequest.headers.length > 0) {
                        preRequest.headers.filter(p => p.value === '').map((m) => request.requestBody.headers.push(m));
                    }

                    if (preRequest?.param && preRequest.param.length > 0) {
                        preRequest.param.filter(p => p.value === '').map((m) => request.requestBody.param.push(m));
                    }
                }
            }
            setTestRequest(request);
            if (request.requestBody !== undefined && request.requestBody.queryStrings !== undefined && request.requestBody.queryStrings.length > 0)
                directFetch = false;
            if (request.requestBody !== undefined && request.requestBody.param !== undefined && request.requestBody.param.length > 0)
                directFetch = false;

            if (request.requestBody !== undefined && request.requestBody.headers !== undefined && request.requestBody.headers.length > 0)
                directFetch = false;

            setIsVisible(true);
            if (directFetch) {
                handleFetch(request);
            }
        }
    }

    const handleTestAuthentication = (e) => {
        if (testRequest !== undefined) {
            let obj = testRequest.authentication;
            obj.token = e.target.value;

            setTestRequest({ ...testRequest, authentication: obj });
        }
    }

    const handleTestQueryString = (val, e) => {

        if (testRequest !== undefined && testRequest.requestBody !== undefined) {
            let obj = testRequest.requestBody;
            let lst = [...obj.queryStrings];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "name")
                    lst.filter((f, i) => val === i)[0].name = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
            }
            obj.queryStrings = lst;

            setTestRequest({ ...testRequest, requestBody: obj });
        }
    }

    const handleTestHeaders = (val, e) => {
        if (testRequest !== undefined && testRequest.requestBody !== undefined) {
            let obj = testRequest.requestBody;
            let lst = [...obj.headers];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "name")
                    lst.filter((f, i) => val === i)[0].name = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
            }
            obj.headers = lst;

            setTestRequest({ ...testRequest, requestBody: obj });
        }
    }

    const handleTestParams = (val, e) => {

        if (testRequest !== undefined && testRequest.requestBody !== undefined) {
            let obj = testRequest.requestBody;
            let lst = [...obj.param];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "name")
                    lst.filter((f, i) => val === i)[0].name = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
            }
            obj.param = lst;

            setTestRequest({ ...testRequest, requestBody: obj });
        }
    }

    const handleChange = (index, e) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];

            obj[e.target.name] = e.target.value;
            list[index] = obj;

        }
        setApiConfigurations(list);
    }

    const handleResponseParams = (index, val, e) => {

        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];

            let lst = [...obj.responseParams];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "path")
                    lst.filter((f, i) => val === i)[0].path = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].variableName = e.target.value;
            }
            obj.responseParams = lst;
            list[index] = obj;

        }
        setApiConfigurations(list);
    }

    useEffect(() => {

        if (settings !== undefined && settings.requestParam !== undefined) {
            setRequestParams(settings.requestParam);
        }
        if (settings !== undefined && settings.apiConfigurations !== undefined) {
            let tabs = [];
            if (settings.apiConfigurations.length > 0)
                settings.apiConfigurations.map(m => tabs.push(''));
            setActiveTabs(tabs);
            setApiConfigurations(settings.apiConfigurations);
        }

    }, [settings]);

    const handleTabs = (index, e) => {
        let tabs = [...activeTabs];
        let obj = tabs.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj[0] = e;
            tabs[index] = obj[0];
        }
        setActiveTabs(tabs);
    }

    const handleRequestParams = (index, val, e) => {

        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];

            let lst = [...obj.param];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "name")
                    lst.filter((f, i) => val === i)[0].name = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
            }
            obj.param = lst;
            list[index] = obj;

        }
        setApiConfigurations(list);
    }

    const handleSelectedRequestParam = (index, val, e) => {

        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];

            let lst = [...obj.param];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "value")
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
                else {
                    let selectedParam = requestParam.filter(f => f.name === e.target.value);
                    if (selectedParam.length > 0 && selectedParam !== []) {
                        lst.filter((f, i) => val === i)[0].name = selectedParam[0].name;
                        lst.filter((f, i) => val === i)[0].value = selectedParam[0].name;
                    }
                }
            }
            obj.param = lst;
            list[index] = obj;

        }
        setApiConfigurations(list);
    }



    const addEndPoint = () => {
        let list = [...apiConfigurations];
        list.push({
            requestName: '',
            requestType: 'GET',
            endPointUrl: '',
            queryString: [],
            preRequest: {
                endPointUrl: ''
            },
            headers: [],
            param: [],
            requestBody: null,
            authentication: {
                authenticationName: 'None',
                authenticationSettings: {
                    user: '',
                    password: '',
                    token: '',
                }
            },
            responseParams: [
                {
                    path: '',
                    variableName: ''
                }
            ]
        });
        let tabs = [...activeTabs];
        tabs.push('');
        setActiveTabs(tabs);
        setApiConfigurations(list);
    }

    const addEndPointResponseParams = (index) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].responseParams];
            lst.push({
                path: '',
                variableName: ''
            });
            obj[0].responseParams = lst;
            list[index] = obj[0];
        }
        setApiConfigurations(list);
    }

    const removeEndPointResponseParams = (index, val) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].responseParams];
            lst = lst.filter((f, i) => i !== val);
            obj[0].responseParams = lst;
            list[index] = obj[0];
        }

        setApiConfigurations(list);
    }

    const addRequestParams = (index) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);

        if (obj.length > 0) {
            let lst = [...obj[0].param];
            lst.push({
                name: '',
                value: ''
            });
            obj[0].param = lst;
            list[index] = obj[0];
        }
        setApiConfigurations(list);
    }

    const removeRequestParams = (index, val) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].responseParams];
            lst = lst.filter((f, i) => i !== val);
            obj[0].param = lst;
            list[index] = obj[0];
        }

        setApiConfigurations(list);
    }

    const handleSave = (index, e) => {
        saveIntegration({ apiConfigurations: apiConfigurations });
    }

    const handleAuthorization = (index, e) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let settings;
            if (e.target.name === 'authenticationName') {
                settings = obj[0].authentication?.authenticationName;
                settings = e.target.value;
                obj[0].authentication.authenticationName = settings;
            }
            else {
                settings = obj[0].authentication?.authenticationSettings;
                settings[e.target.name] = e.target.value;
                obj[0].authentication.authenticationSettings = settings;
            }
            if (settings !== undefined) {
                list[index] = obj[0];

            }
        }
        setApiConfigurations(list);
    }

    const handlePreRequestScript = (index, e) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let settings;
            settings = obj[0].preRequest?.endPointUrl;
            settings = e.target.value;
            obj[0].preRequest.endPointUrl = settings;
        }
        if (settings !== undefined) {
            list[index] = obj[0];

        }
        setApiConfigurations(list);
    }

    const handleRequestBody = (index, e) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        list[index].requestBody = e.target.value;
        setApiConfigurations(list);
    }

    const removeEndPoint = (index) => {
        let list = [...apiConfigurations];
        list = list.filter((f, i) => index !== i);
        let tabs = [...activeTabs];
        tabs = tabs.filter((f, i) => index !== i);
        setActiveTabs(tabs);
        setApiConfigurations(list);
    }

    const addQueryString = (index) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].queryString];
            lst.push({
                name: '',
                value: ''
            });
            obj[0].queryString = lst;
            list[index] = obj[0];
        }
        setApiConfigurations(list);
    }


    const removeQueryString = (index, val) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].queryString];
            lst = lst.filter((f, i) => i !== val);
            obj[0].queryString = lst;
            list[index] = obj[0];
        }

        setApiConfigurations(list);
    }

    const handleQueryString = (index, val, e) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];
            let lst = [...obj.queryString];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "name")
                    lst.filter((f, i) => val === i)[0].name = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
            }
            obj.queryString = lst;
            list[index] = obj;
        }
        setApiConfigurations(list);
    }


    const addHeaders = (index) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].headers];
            lst.push({
                name: '',
                value: ''
            });
            obj[0].headers = lst;
            list[index] = obj[0];
        }
        setApiConfigurations(list);
    }


    const removeHeaders = (index, val) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            let lst = [...obj[0].headers];
            lst = lst.filter((f, i) => i !== val);
            obj[0].headers = lst;
            list[index] = obj[0];
        }

        setApiConfigurations(list);
    }

    const handleHeaders = (index, val, e) => {
        let list = [...apiConfigurations];
        let obj = list.filter((f, i) => index === i);
        if (obj.length > 0) {
            obj = obj[0];
            let lst = [...obj.headers];
            if (lst.filter((f, i) => val === i).length > 0) {
                if (e.target.name === "name")
                    lst.filter((f, i) => val === i)[0].name = e.target.value;
                else
                    lst.filter((f, i) => val === i)[0].value = e.target.value;
            }
            obj.headers = lst;
            list[index] = obj;
        }
        setApiConfigurations(list);
    }


    const handleFetch = (body) => {
        setTestResponse();
        let isValid = true;
        if (testRequest !== undefined) {
            if (testRequest.authentication !== undefined && testRequest.authentication.token !== undefined &&
                testRequest.authentication.token === '') {
                isValid = false;
                NotificationManager.error(
                    "",
                    "Please enter the token correctly",
                    3000,
                    null,
                    null,
                    "error"
                );
            }
            else if (testRequest?.requestBody && testRequest.requestBody?.queryStrings
                && testRequest.requestBody.queryStrings.length > 0 &&
                testRequest.requestBody.queryStrings.filter(f => f.value === '').length > 0) {
                isValid = false;
                NotificationManager.error(
                    "",
                    "Please enter all the query strings correcty",
                    3000,
                    null,
                    null,
                    "error"
                );
            } else if (testRequest?.requestBody && testRequest.requestBody?.param
                && testRequest.requestBody.param.length > 0 &&
                testRequest.requestBody.param.filter(f => f.value === '').length > 0) {
                isValid = false;
                NotificationManager.error(
                    "",
                    "Please enter all the params correcty",
                    3000,
                    null,
                    null,
                    "error"
                );
            }
        }
        if (isValid) {
            NotificationManager.success(
                "",
                "Request is fetching, it takes few moments.",
                3000,
                null,
                null,
                "success"
            );
            let bodyData = body !== undefined ? body : testRequest;
            let lst = [];
            if (bodyData.requestBody !== undefined) {
                if (bodyData.requestBody.param !== undefined && bodyData.requestBody.param !== null && bodyData.requestBody.param.length > 0)
                    bodyData.requestBody.param.map(m => lst.push(m));

                if (bodyData.requestBody.queryStrings !== undefined && bodyData.requestBody.queryStrings !== null &&
                    bodyData.requestBody.queryStrings.length > 0)
                    bodyData.requestBody.queryStrings.map(m => lst.push(m));

                if (bodyData.requestBody.headers !== undefined && bodyData.requestBody.headers !== null &&
                    bodyData.requestBody.headers.length > 0)
                    bodyData.requestBody.headers.map(m => lst.push(m));

                bodyData.requestBody.bodyParams = lst;
            }
            AxiosAPI({
                method: 'post',
                url: `${API_REST_API}/fetch`,
                data: bodyData
            }).then((res) => {
                if (res.data.response !== undefined) {
                    setTestResponse(res.data);
                } else {
                    NotificationManager.error(
                        "",
                        "Request is not valid",
                        3000,
                        null,
                        null,
                        "error"
                    );
                }
            });
        }
    }

    return (<Fragment>
        <Card className="mb-4">
            <CardBody>
                <style>{style_css}</style>
                <div className="text-center mb-2">
                    <h6>Requests</h6>
                </div>
                <Separator className="mb-3" />
                <div className="row mt-1 ml-0 mb-3">
                    <Colxx md="12">
                        {apiConfigurations !== undefined && apiConfigurations.length > 0 && (
                            <Fragment>
                                {apiConfigurations.map((m, index) =>
                                    <Fragment>
                                        <Card className="mb-3">
                                            <CardBody>
                                                <Colxx md="12" className="mb-2">
                                                    <Input type="text" name="requestName" placeholder="Request Name" value={m.requestName} onChange={(e) => handleChange(index, e)}>
                                                    </Input>
                                                </Colxx>
                                                <Colxx md="12" className="mb-2">
                                                    <InputGroup>
                                                        <InputGroupAddon addonType="prepend">
                                                            <Input type="select" name="requestType" placeholder="Url" value={m.requestType} onChange={(e) => handleChange(index, e)}>
                                                                {requestTypes.map((r) =>
                                                                    <option value={r}>{r}</option>
                                                                )}
                                                            </Input></InputGroupAddon>
                                                        <Input type="text" name="endPointUrl" value={m.endPointUrl} onChange={(e) => handleChange(index, e)}>
                                                        </Input>
                                                    </InputGroup>
                                                </Colxx>
                                                <Colxx md="12" className="mb-2">
                                                    <CardHeader className="pl-0 pr-0">
                                                        <Nav tabs className="card-header-tabs ml-0 mr-0" style={{ backgroundColor: 'white', border: '1px solid lightgray' }}>
                                                            <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "Params",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "Params");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Params
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "Headers",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "Headers");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Headers
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "Authentication",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "Authentication");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Authentication
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "QueryString",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "QueryString");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Query String
                                                                </NavLink>
                                                            </NavItem>
                                                            {m.requestType === 'POST' && <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "Body",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "Body");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Body
                                                                </NavLink>
                                                            </NavItem>}
                                                            <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "PreRequestScript",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "PreRequestScript");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Pre-request Script
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className="w-auto text-center">
                                                                <NavLink
                                                                    className={classnames({
                                                                        active: (activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0 &&
                                                                            activeTabs.filter((f, i) => i === index)[0]) === "ResponseParams",
                                                                        "nav-link": true
                                                                    })}
                                                                    onClick={() => {
                                                                        handleTabs(index, "ResponseParams");
                                                                    }}
                                                                    to="#"
                                                                >
                                                                    Response
                                                                </NavLink>
                                                            </NavItem>

                                                        </Nav>
                                                        <TabContent activeTab={(activeTabs.length > 0 && activeTabs.filter((f, i) => i === index).length > 0) &&
                                                            activeTabs.filter((f, i) => i === index)[0]}>
                                                            <TabPane tabId="Params" className="chat-app-tab-pane">
                                                                <Card className="mt-3">
                                                                    <CardBody>
                                                                        <Colxx md="12" className="mb-2">
                                                                            {(m.param !== undefined && m.param.length > 0) && m.param.map((r, i) =>
                                                                                <Row className="mb-2">
                                                                                    <Colxx md="4">
                                                                                        <Input type="select" name="name" placeholder="{Name}" value={r.name}
                                                                                            onChange={(e) => handleSelectedRequestParam(index, i, e)}>
                                                                                            <option value={""}>Please Select</option>
                                                                                            {(requestParam !== undefined && requestParam.length > 0) &&
                                                                                                requestParam.map((r) =>
                                                                                                    <option value={r.name}>{r.name}</option>
                                                                                                )}
                                                                                        </Input>
                                                                                    </Colxx>
                                                                                    <Colxx md="7">
                                                                                        <Input type="text" name="value" placeholder="Value" value={r.value} onChange={(e) => handleRequestParams(index, i, e)}>
                                                                                        </Input>
                                                                                    </Colxx>
                                                                                    <Colxx md="1">
                                                                                        <Button onClick={() => removeRequestParams(index, i)} size="xs" color='danger' className='mb-2' outline>X</Button>
                                                                                    </Colxx>
                                                                                </Row>
                                                                            )}
                                                                            <Row>
                                                                                <Colxx md="12" className="text-left mb-2 mr-2">
                                                                                    <Button onClick={() => addRequestParams(index)} size="xs" color='primary' outline>+ Add Params</Button>
                                                                                </Colxx>
                                                                            </Row>
                                                                        </Colxx>
                                                                    </CardBody>
                                                                </Card>
                                                            </TabPane>
                                                            <TabPane tabId="Headers" className="chat-app-tab-pane">
                                                                <Card className="mt-3">
                                                                    <CardBody>
                                                                        {(m.headers !== undefined && m.headers.length > 0) && m.headers.map((r, i) =>
                                                                            <Row className="mb-2">
                                                                                <Colxx md="4">
                                                                                    <Input type="text" name="name" placeholder="name" value={r.name} onChange={(e) => handleHeaders(index, i, e)}>
                                                                                    </Input>
                                                                                </Colxx>
                                                                                <Colxx md="7">
                                                                                    <Input type="text" name="value" placeholder="Value" value={r.value} onChange={(e) => handleHeaders(index, i, e)}>
                                                                                    </Input>
                                                                                </Colxx>
                                                                                <Colxx md="1">
                                                                                    <Button onClick={() => removeHeaders(index, i)} size="xs" color='danger' className='mb-2' outline>X</Button>
                                                                                </Colxx>
                                                                            </Row>
                                                                        )}
                                                                        <Row>
                                                                            <Colxx md="12" className="text-left mb-2 mr-2">
                                                                                <Button onClick={() => addHeaders(index)} size="xs" color='primary' outline>+ Add Headers</Button>
                                                                            </Colxx>
                                                                        </Row>

                                                                    </CardBody>
                                                                </Card>
                                                            </TabPane>
                                                            <TabPane tabId="Authentication" className="chat-app-tab-pane">
                                                                <Card className="mt-3">
                                                                    <CardBody>
                                                                        <Colxx md="12" className="mb-2">
                                                                            <Row>
                                                                                <Colxx md="12" className="mb-2">
                                                                                    <Input type="select" name="authenticationName" value={m.authentication?.authenticationName}
                                                                                        onChange={(e) => handleAuthorization(index, e)}>
                                                                                        {authentication.map((r) =>
                                                                                            <option value={r.value}>{r.label}</option>
                                                                                        )}
                                                                                    </Input>
                                                                                </Colxx>
                                                                            </Row>
                                                                            {(m.authentication?.authenticationName && m.authentication.authenticationName !== undefined && m.authentication.authenticationName === 'BasicAuth') &&
                                                                                <Fragment>
                                                                                    <Row>
                                                                                        <Colxx md="6" className="mb-2">
                                                                                            <Label>User</Label>
                                                                                            <Input type="text" name="user" placeholder="User"
                                                                                                value={m.authentication?.authenticationSettings?.user} onChange={(e) => handleAuthorization(index, e)}>
                                                                                            </Input>
                                                                                        </Colxx>
                                                                                        <Colxx md="6" className="mb-2">
                                                                                            <Label>Password</Label>
                                                                                            <Input type="text" name="password" placeholder="Password"
                                                                                                value={m.authentication?.authenticationSettings?.password} onChange={(e) => handleAuthorization(index, e)}>
                                                                                            </Input>
                                                                                        </Colxx>
                                                                                    </Row>
                                                                                </Fragment>
                                                                            }
                                                                        </Colxx>
                                                                        {(m.authentication?.authenticationName && m.authentication.authenticationName !== undefined && m.authentication.authenticationName === 'BearerToken') &&
                                                                            <Fragment>
                                                                                <Colxx md="12" className="mb-2">
                                                                                    <Label>Bearer Token</Label>
                                                                                    <Input type="text" name="token" placeholder="Token"
                                                                                        value={m.authentication?.authenticationSettings?.token} onChange={(e) => handleAuthorization(index, e)}>
                                                                                    </Input>
                                                                                </Colxx>
                                                                            </Fragment>
                                                                        }
                                                                    </CardBody>
                                                                </Card>
                                                            </TabPane>
                                                            <TabPane tabId="QueryString" className="chat-app-tab-pane">
                                                                {/* <Colxx md="12" className="mb-2">
                                                            <h6>queryString</h6>
                                                        </Colxx> */}
                                                                <Card className="mt-3">
                                                                    <CardBody>

                                                                        {(m.queryString !== undefined && m.queryString.length > 0) && m.queryString.map((q, qindex) => <Fragment>
                                                                            <Colxx md="12" className="mb-2">
                                                                                <Row className="mb-2">
                                                                                    <Colxx md="4">
                                                                                        <Input type="text" name="name" placeholder="Name" value={q.name} onChange={(e) => handleQueryString(index, qindex, e)}>
                                                                                        </Input>
                                                                                    </Colxx>
                                                                                    <Colxx md="7">
                                                                                        <Input type="text" name="value" placeholder="Value" value={q.value} onChange={(e) => handleQueryString(index, qindex, e)}>
                                                                                        </Input>
                                                                                    </Colxx>
                                                                                    <Colxx md="1">
                                                                                        <Button onClick={() => removeQueryString(index, qindex)} size="xs" color='danger' className='mb-2' outline>X</Button>
                                                                                    </Colxx>
                                                                                </Row>
                                                                            </Colxx>
                                                                        </Fragment>)}

                                                                        <Colxx md="12" className="text-left mb-2 mr-2">
                                                                            <Button onClick={() => addQueryString(index)} size="xs" color='primary' outline>+ Add Query String</Button>
                                                                        </Colxx>
                                                                    </CardBody>
                                                                </Card>
                                                            </TabPane>
                                                            <TabPane tabId="PreRequestScript" className="chat-app-tab-pane">
                                                                <Card className="mt-3">
                                                                    <CardBody>

                                                                        <Colxx md="12" className="mb-2">
                                                                            <Input type="select" name="endPointUrl" value={m.preRequest?.endPointUrl}
                                                                                onChange={(e) => handlePreRequestScript(index, e)}>
                                                                                <option value="">Please Select</option>
                                                                                {apiConfigurations.map((r) =>
                                                                                    <option value={r.endPointUrl}>{r.endPointUrl}</option>
                                                                                )}
                                                                            </Input>
                                                                        </Colxx>
                                                                    </CardBody>
                                                                </Card>
                                                            </TabPane>
                                                            {m.requestType !== 'GET' &&
                                                                <TabPane tabId="Body" className="chat-app-tab-pane">
                                                                    <Card className="mt-3">
                                                                        <CardBody>

                                                                            <Colxx md="12" className="mb-2">
                                                                                <Input type="textarea" style={{ height: '100px' }} name="requestBody" value={m.requestBody}
                                                                                    onChange={(e) => handleRequestBody(index, e)}>
                                                                                </Input>
                                                                            </Colxx>
                                                                        </CardBody>
                                                                    </Card>
                                                                </TabPane>
                                                            }
                                                            <TabPane tabId="ResponseParams" className="chat-app-tab-pane">
                                                                <Card className="mt-3">
                                                                    <CardBody>
                                                                        <Colxx md="12" className="mb-2">
                                                                            <Row className="">
                                                                                <Colxx md="7">
                                                                                    <Label>Path</Label>
                                                                                </Colxx>
                                                                                <Colxx md="4">
                                                                                    <Label>Store As</Label>
                                                                                </Colxx>
                                                                            </Row>
                                                                        </Colxx>
                                                                        <Colxx md="12" className="mb-2">
                                                                            {(m.responseParams !== undefined && m.responseParams.length > 0) && m.responseParams.map((r, i) =>
                                                                                <Row className="mb-1">
                                                                                    <Colxx md="7">
                                                                                        <Input type="text" name="path" placeholder="Path" value={r.path} onChange={(e) => handleResponseParams(index, i, e)}>
                                                                                        </Input>
                                                                                    </Colxx>
                                                                                    <Colxx md="4">
                                                                                        <Input type="text" name="variableName" placeholder="Name" value={r.variableName} onChange={(e) => handleResponseParams(index, i, e)}>
                                                                                        </Input>
                                                                                    </Colxx>
                                                                                    <Colxx md="1">
                                                                                        <Button onClick={() => removeEndPointResponseParams(index, i)} size="xs" color='danger' className='mb-2 mt-2' outline>X</Button>
                                                                                    </Colxx>
                                                                                </Row>
                                                                            )}
                                                                        </Colxx>
                                                                        <Colxx md="12" className="text-left mb-2 mr-2">
                                                                            <Button onClick={() => addEndPointResponseParams(index)} size="xs" color='primary' outline>+ Add Response</Button>
                                                                        </Colxx>
                                                                    </CardBody>
                                                                </Card>
                                                            </TabPane>
                                                        </TabContent>
                                                    </CardHeader>
                                                </Colxx>
                                                <Colxx md="12" className="text-right mb-2">
                                                    <Button onClick={() => removeEndPoint(index)} style={{ color: 'red', borderColor: 'red' }} size="xs" outline>Delete</Button>
                                                    <Button size="xs" onClick={() => handleTestConfiguration(index)} color='secondary' className='ml-2' outline>Test Request</Button>
                                                </Colxx>
                                            </CardBody>
                                        </Card>
                                    </Fragment>)}
                            </Fragment>
                        )}


                    </Colxx>
                    <Colxx md="12" className="text-left">
                        <Button onClick={addEndPoint} color='primary' size="xs" outline>+ Add Request</Button>
                    </Colxx>

                </div>
                <Separator className="mb-2"></Separator>
                <Colxx md="12" className="text-center mb-2">
                    <Button onClick={() => handleSave()} color='primary' size="xs" >Save</Button>
                </Colxx>
            </CardBody>
        </Card>
        <Modal isOpen={isVisible} toggle={toggle} size="xl">
            <ModalHeader toggle={toggle}>
                {testRequest !== undefined && testRequest?.requestName}
            </ModalHeader>
            <ModalBody>
                {testRequest !== undefined &&
                    <Fragment>
                        {(testRequest.authentication !== undefined && testRequest.authentication.token !== undefined) &&
                            <Fragment>
                                <Colxx md="12" className="mb-2">
                                    <h6>
                                        Bearer Token
                                    </h6>
                                </Colxx>
                                <Colxx md="12" className="mb-2">
                                    <Input type="text" name="Token"
                                        placeholder="Token" value={testRequest.authentication.token}
                                        onChange={(e) => handleTestAuthentication(e)}>
                                    </Input>
                                </Colxx>
                            </Fragment>
                        }
                        <Colxx md="12" className="mb-2">
                            {(testRequest.requestBody !== undefined && testRequest.requestBody.param !== undefined &&
                                testRequest.requestBody.param.length > 0) &&
                                testRequest.requestBody.param.map((m, index) => <Fragment>
                                    <Row className="mb-2">
                                        <Colxx md="12" className="mb-2">
                                            <h6>
                                                Request Param
                                            </h6>
                                        </Colxx>
                                        <Colxx md="6">
                                            <Input type="text" name="name" placeholder="Name" value={m.name} onChange={(e) => handleTestParams(index, e)}>
                                            </Input>
                                        </Colxx>
                                        <Colxx md="6">
                                            <Input type="text" name="value" placeholder="Value" value={m.value} onChange={(e) => handleTestParams(index, e)}>
                                            </Input>
                                        </Colxx>
                                    </Row>
                                </Fragment>
                                )}
                        </Colxx>
                        <Colxx md="12" className="mb-2">
                            {(testRequest.requestBody !== undefined && testRequest.requestBody.queryStrings !== undefined &&
                                testRequest.requestBody.queryStrings.length > 0) &&
                                testRequest.requestBody.queryStrings.map((m, index) => <Fragment>
                                    <Row className="mb-2">
                                        <Colxx md="12" className="mb-2">
                                            <h6>
                                                Query String
                                            </h6>
                                        </Colxx>
                                        <Colxx md="6">
                                            <Input type="text" name="name" placeholder="Name" value={m.name} onChange={(e) => handleTestQueryString(index, e)}>
                                            </Input>
                                        </Colxx>
                                        <Colxx md="6">
                                            <Input type="text" name="value" placeholder="Value" value={m.value} onChange={(e) => handleTestQueryString(index, e)}>
                                            </Input>
                                        </Colxx>
                                    </Row>
                                </Fragment>
                                )}
                        </Colxx>
                        <Colxx md="12" className="mb-2">
                            {(testRequest.requestBody !== undefined && testRequest.requestBody.headers !== undefined &&
                                testRequest.requestBody.headers.length > 0) &&
                                testRequest.requestBody.headers.filter(f => f.value == '').map((m, index) => <Fragment>
                                    <Row className="mb-2">
                                        <Colxx md="6">
                                            <Input type="text" name="name" placeholder="Name" value={m.name} onChange={(e) => handleTestHeaders(index, e)}>
                                            </Input>
                                        </Colxx>
                                        <Colxx md="6">
                                            <Input type="text" name="value" placeholder="Value" value={m.value} onChange={(e) => handleTestHeaders(index, e)}>
                                            </Input>
                                        </Colxx>
                                    </Row>
                                </Fragment>
                                )}
                        </Colxx>
                        {(testRequest !== undefined && testRequest.requestBody !== undefined && testRequest.requestBody.body !== undefined &&
                            testRequest.requestBody.body !== null && testRequest.requestBody.body !== '') &&
                            <Colxx md="12" className="mb-2">
                                <Row className="mb-2">
                                    <Colxx md="12" className="mb-2">
                                        <h6>
                                            Request Body
                                        </h6>
                                    </Colxx>
                                    <Colxx md="12" className="mb-2">
                                        <Input
                                            type="textarea"
                                            value={testRequest.requestBody.body}
                                            style={{ height: '100px' }}
                                        />
                                    </Colxx>
                                </Row>
                            </Colxx>}
                        {(testResponse !== undefined && testResponse.response !== undefined) && <Colxx md="12" className="mb-2">
                            <Row className="mb-2">
                                <Colxx md="12" className="mb-2">
                                    <h6>
                                        Response
                                    </h6>
                                </Colxx>
                                <Colxx md="12" className="mb-2">
                                    <Input
                                        type="textarea"
                                        value={JSON.stringify(testResponse)}
                                        style={{ height: '100px' }}
                                    />
                                </Colxx>
                            </Row>
                        </Colxx>}
                    </Fragment>
                }
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => handleFetch()} className="ml-2">Fetch</Button>
                <Button color="secondary" onClick={toggle} className="ml-2">Close</Button>
            </ModalFooter>
        </Modal >
    </Fragment >);
}